import permissionsMap from '@/modules/auth/helper/permissionsMap'

const Module = () =>
  import(/* webpackChunkName: "notes-module" */ '@/modules/notes/Module.vue')
const NotesHome = () =>
  import(
    /* webpackChunkName: "notes-module" */ '@/modules/notes/views/NotesHome.vue'
  )

const routes = [
  {
    path: '/notes',
    component: Module,
    children: [
      {
        name: 'notes',
        path: '/',
        component: NotesHome,
      },
    ],
    meta: {
      permission: permissionsMap.note.list,
      requiresAuth: true,
    },
  },
]

export default routes
